<template>
  <div class="loading">
    <div class="center">
      <i class="icon-spinner icon-spin"></i>
      <div>Cargando</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingAnimation',
};
</script>
<style lang="scss" scaped>
</style>
